export default theme => ({
  list: {
    padding: '0 15px'
  },
  item: {
    padding: '10px 0',
    borderBottom: '1px solid #ccc',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  title: {
    paddingRight: 10,
    display: 'block'
  },
  author: {
    fontSize: 11
  }
});